<template>
  <div>
    <ContentHeader :path-info="pathInfo" :path-set-type="'replace'" />
    <div class="content-container" v-loading="infoLoading">
      <!-- 商品主体信息 -->
      <div class="item-detail">
        <!-- 左区域 -->
        <div class="item-image">
          <div>
            <div class="item-image-large">
              <img :src="getImageUrl(showImage)" />
            </div>
            <div class="item-image-preview">
              <div
                class="item-image-small cursor"
                :class="{ active: index === curIndex }"
                v-for="(item, index) in itemInfo.imageList"
                :key="index"
                @mouseover="handleShow(item.imageFileUri, index)"
              >
                <img :src="getImageUrl(item.imageFileUri)" />
              </div>
            </div>
            <i class="iconfont iconlove-b cursor" title="加入常用物料" v-if="!itemInfo.isFavorite" @click="inFavorite"></i>
            <i class="iconfont iconlove-b cursor" title="取消加入常用物料" style="color: #C8102D;" v-else @click="outFavorite"></i>
          </div>
          <div class="rate" v-if="itemInfo.qualityScore">
            <div>
              <div class="rate-item">
                <span>物料质量 ：</span>
                <el-rate
                  v-model="itemInfo.qualityScore"
                  disabled
                  :colors="['#c8102d', '#c8102d', '#c8102d']"
                  text-color="#c8102d"
                  score-template="{value}"
                ></el-rate>
                <span class="rate-item-score">{{itemInfo.qualityScore | formatScore}}</span>
              </div>
              <div class="rate-item">
                <span>物料美观 ：</span>
                <el-rate
                  v-model="itemInfo.appearanceScore"
                  disabled
                  :colors="['#c8102d', '#c8102d', '#c8102d']"
                  text-color="#c8102d"
                  score-template="{value}"
                ></el-rate>
                <span class="rate-item-score">{{itemInfo.appearanceScore | formatScore}}</span>
              </div>
              <div class="rate-item">
                <span>物流服务 ：</span>
                <el-rate
                  v-model="itemInfo.serviceScore"
                  disabled
                  :colors="['#c8102d', '#c8102d', '#c8102d']"
                  text-color="#c8102d"
                  score-template="{value}"
                ></el-rate>
                <span class="rate-item-score">{{itemInfo.serviceScore | formatScore}}</span>
              </div>
            </div>
          </div>
          <div v-else class="rate-nothing">暂无评分</div>
        </div>
        <!-- 右区域 -->
        <div class="item-info" :class="{ 'item-info-print': itemInfo.isPrints }">
          <div class="item-title">{{ itemInfo.itemName }}</div>
          <div class="item-msg" v-if="!itemInfo.isPrints">集中下单日（下单给供应商）：每月15日、30日15:00前</div>
          <!-- menu和non-menu -->
          <div class="item-info-box" v-if="!itemInfo.isPrints">
            <el-row class="item-info-detail">
              <el-col :span="12">
                <div>SAP物料编码：{{ itemInfo.itemCode }}</div>
                <!-- <div v-if="itemInfo.itemCategory">分类：{{ itemInfo.itemCategory.categoryName }}</div> -->
                <div>分类：{{ itemInfo.secondCatalogueName }}</div>
                <div>供应商名称：{{ itemInfo.produceSupplierName }}</div>
                <div v-if="itemInfo.baseLogisticsSupplierDTO">联系人：{{ itemInfo.baseLogisticsSupplierDTO.supplierPerson }}</div>
                <div v-if="itemInfo.baseLogisticsSupplierDTO">
                  联系人电话：{{
                  itemInfo.baseLogisticsSupplierDTO.supplierPhone
                  }}
                </div>
                <div v-if="showQty()">{{ showQty() }}</div>
              </el-col>
              <el-col :span="12" class="info-important">
                <div>
                  合同到期日：{{ itemInfo.contractEnd | parseDate }}
                  <span class="contract-endtime" v-if="endTime < 0">剩余 0 天</span>
                  <span class="contract-endtime" v-else>剩余 {{endTime}} 天</span>
                </div>
                <div>工厂最小起订量：{{ itemInfo.factoryMOQ | thousandSymbol}}</div>
                <!-- 非menu商品显示 除了印刷品，其他menu的商品都不显示-->
                <div
                  v-if="
                    !(itemInfo.categoryId != 20 && itemInfo.isStandard === 1)
                  "
                >工厂最小起运量：{{ itemInfo.factoryMQ | thousandSymbol}}</div>
                <div v-if="itemInfo.baseLogisticsSupplierDTO" style="font-weight: normal">
                  联系人邮箱：{{
                  itemInfo.baseLogisticsSupplierDTO.supplierMail
                  }}
                </div>
              </el-col>
            </el-row>
          </div>

          <!-- 印刷品 -->
          <div class="item-info-box" v-else>
            <el-row class="item-info-detail">
              <el-col :span="12">
                <div>物料编码：{{ itemInfo.itemCode }}</div>
                <!-- <div>分类：{{ itemInfo.itemCategory.categoryName }}</div> -->
                <div>分类：{{ itemInfo.secondCatalogueName }}</div>
                <div style="font-weight:700">
                  合同到期日：{{ itemInfo.contractEnd | parseDate }}
                  <span class="contract-endtime" v-if="endTime < 0">剩余 0 天</span>
                  <span class="contract-endtime" v-else>剩余 {{endTime}} 天</span>
                </div>
                <div style="font-weight:700">最小起订量：{{ itemInfo.factoryMOQ | thousandSymbol}}</div>
                <!-- 非menu商品显示 除了印刷品，其他menu的商品都不显示-->
                <div
                  v-if="
                    !(itemInfo.categoryId != 20 && itemInfo.isStandard === 1)
                  "
                >最小起运量：{{ itemInfo.factoryMQ | thousandSymbol}}</div>
                <div>供应商名称：{{ itemInfo.produceSupplierName }}</div>
                <div v-if="itemInfo.baseLogisticsSupplierDTO">联系人：{{ itemInfo.baseLogisticsSupplierDTO.supplierPerson }}</div>
                <div v-if="itemInfo.baseLogisticsSupplierDTO">
                  联系人电话：{{
                  itemInfo.baseLogisticsSupplierDTO.supplierPhone
                  }}
                </div>
                <div v-if="showQty()">{{ showQty() }}</div>
              </el-col>
              <el-col :span="12">
                <div>制作周期：{{ itemInfo.productTime }}天</div>
                <div>物流周期：{{ itemInfo.logisticsTime }}天</div>
                <div v-if="itemInfo.itemPrintsDTO">
                  <div>材质要求：{{ itemInfo.itemPrintsDTO.materialSpecs }}</div>
                  <div>印刷要求：{{ itemInfo.itemPrintsDTO.printSpecs }}</div>
                  <div>覆膜方式：{{ itemInfo.itemPrintsDTO.filmMulch }}</div>
                  <div>印刷方式：{{ itemInfo.itemPrintsDTO.printMethod }}</div>
                  <div>模切要求：{{ itemInfo.itemPrintsDTO.dieCutting }}</div>
                </div>
                <div v-else>
                  <div>材质要求：</div>
                  <div>印刷要求：</div>
                  <div>覆膜方式：</div>
                  <div>印刷方式：</div>
                  <div>模切要求：</div>
                </div>
                <div v-if="itemInfo.baseLogisticsSupplierDTO">
                  联系人邮箱：{{
                  itemInfo.baseLogisticsSupplierDTO.supplierMail
                  }}
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="item-info-box">
            <el-row class="item-info-detail" v-if="soleBrandFlag">
              <el-col :span="24">
                <div>
                  品牌：
                  <span v-for="(item, index) in itemParBrandList" :key="index">
                    <span>
                      {{
                      `${item.abiBrandName} ${
                      item.brandGroup ? "-" : ""
                      } ${item.brandGroup || ""}`
                      }}
                    </span>
                    <span v-if="index < itemParBrandList.length - 1">,</span>
                  </span>
                </div>
              </el-col>
              <el-col :span="24">
                <div>
                  子品牌：
                  <span v-for="(item, index) in itemSubBrandList" :key="index">
                    <span v-if="item.brandGroup">
                      {{
                      `${item.abiBrandName} ${
                      item.brandGroup ? "-" : ""
                      } ${item.brandGroup || ""}`
                      }}
                    </span>
                    <span v-if="index < itemSubBrandList.length - 1">,</span>
                  </span>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="item-brand" v-if="!soleBrandFlag">
            <el-row :span="12">
              <el-col :span="2">
                <div>品牌：</div>
              </el-col>
              <el-col :span="10">
                <el-select v-model="queryForm.abiBrandId" @change="getSubBrandList" placeholder="选择品牌" clearable filterable size="mini">
                  <el-option
                    v-for="(item, index) in itemParBrandList"
                    :label="
                      `${item.abiBrandName} ${
                        item.brandGroup ? '-' : ''
                      } ${item.brandGroup || ''}`
                    "
                    :value="item.abiBrandId"
                    :key="index"
                    style="max-width: 400px"
                  />
                </el-select>

              </el-col>
              <el-col :span="2" v-if="queryForm.abiBrandId">
                <div>子品牌:</div>
              </el-col>
              <el-col :span="10" v-if="queryForm.abiBrandId">
                <el-select v-model="queryForm.subBrandId" placeholder="选择子品牌" clearable size="mini">
                  <el-option
                    v-for="(item, index) in showSubBrandList"
                    :label="
                      `${item.abiBrandName} ${
                        item.brandGroup ? '-' : ''
                      } ${item.brandGroup || ''}`
                    "
                    :value="item.abiBrandId"
                    :key="index"
                    style="max-width: 400px"
                  />
                </el-select>
              </el-col>
            </el-row>
          </div>

          <div class="item-mmr12">
            <el-row :span="12">
              <el-col :span="2">
                <div>MMR12：</div>
              </el-col>
              <el-col :span="10">
                <el-select v-model="queryForm.mmr12" placeholder="选择MMR12编码" clearable size="mini">
                  <el-option
                    v-for="(item, index) in mmr12List"
                    :label="`${item.code}-${item.name}`"
                    :value="item.code"
                    :key="index"
                    :title="`${item.code}-${item.name}`"
                    style="max-width: 400px"
                  />
                </el-select>
              </el-col>
              <el-col :span="2" v-if="queryForm.mmr12">
                <div>总账科目:</div>
              </el-col>
              <el-col :span="10" v-if="queryForm.mmr12">
                <el-select v-model="queryForm.ledgerAccount" placeholder="选择总账科目" clearable size="mini">
                  <el-option
                    v-for="(item, index) in ledgerList"
                    :label="
                      `${item.ledgerAccountCode}-${item.ledgerAccountName}`
                    "
                    :value="item.ledgerAccountCode"
                    :key="index"
                    :title="
                      `${item.ledgerAccountCode}-${item.ledgerAccountName}`
                    "
                    style="max-width: 400px"
                  />
                </el-select>
              </el-col>
            </el-row>
          </div>

          <div class="item-entity">
            <el-row :span="12">
              <el-col :span="2">
                <div>工厂：</div>
              </el-col>
              <el-col :span="22">
                <el-select v-model="queryForm.companyEntityId" placeholder="选择工厂" clearable size="mini" filterable>
                  <el-option
                    v-for="(item, index) in entityList"
                    :label="item.entityCode + '-' + item.entityName"
                    :value="item.entityId"
                    :key="index"
                  />
                </el-select>
              </el-col>
            </el-row>
          </div>

          <div class="item-price">
            <span class="item-price-unit">￥{{ getPrice(itemInfo) | thousandSymbol }}</span>
            <!-- <span v-if="itemInfo.pocmPriceType === '01' || !itemInfo.pocmPriceType" class="item-price-desc">(商品含税价)</span> -->
            <span class="item-price-desc">(不含税价)</span>
            <span class="item-price-msg" v-if="itemInfo.priceUnitQuantity !== 1">
              (每{{ itemInfo.priceUnitQuantity }}个商品{{
              getPrice(itemInfo)
              }}元)
            </span>
          </div>
          <div class="item-price-extra">
            <span
              class="item-price-unit"
              v-if="itemInfo.pocmPriceType === '01' || !itemInfo.pocmPriceType"
            >￥{{ getTaxPrice(itemInfo) | thousandSymbol }}</span>
            <span class="item-price-unit" v-else>￥0</span>
            <span class="item-price-desc">（税额）</span>
            <span
              class="item-price-msg"
              v-if="
                itemInfo.priceUnitQuantity !== 1 &&
                  itemInfo.pocmPriceType === '01'
              "
            >
              (每{{ itemInfo.priceUnitQuantity }}个商品{{
              getTaxPrice(itemInfo)
              }}元)
            </span>
          </div>
          <div class="item-price-extra item-price-bottom">
            <span class="item-price-unit">￥{{ itemInfo.extraFee | thousandSymbol}}</span>
            <span class="item-price-desc">（运费）</span>
            <span class="item-price-msg" v-if="itemInfo.priceUnitQuantity !== 1 && itemInfo.extraFee !== 0">
              (每{{ itemInfo.priceUnitQuantity }}个商品{{
              itemInfo.extraFee
              }}元)
            </span>
          </div>
          <div class="item-quantity">
            <div class="teamOrder-box" v-if="itemInfo.teamOrderStatus === '02'">
              <div class="teamOrder">拼单状态: {{itemInfo.teamOrderStatusName}}</div>
              <div class="teamOrder">拼单截止时间: {{teamOrderEndTime | parseDate}}</div>
              <div class="teamOrder sumPurchaseQty">
                <span>已拼单数量:</span>
                <div class="item-progress">
                  <el-progress
                    :stroke-width="15"
                    :text-inside="true"
                    :percentage="getPercentage(itemInfo)"
                    :format="getShowQuantity(itemInfo)"
                    color="rgb(218, 63, 63)"
                  ></el-progress>
                  <div>{{ getShowMOQ(itemInfo) | thousandSymbol}}</div>
                </div>
              </div>
            </div>
            <span class="item-quantity-info">数量</span>
            <el-input-number v-model="queryForm.itemQuantity" @change="handleQuantityChange" :min="1" label="描述文字" size="small"></el-input-number>
            <span class="item-price-total">小计：{{ totalAmount | thousandSymbol}}元</span>
          </div>
          <div class="order-msg" v-if="!itemInfo.isPrints">说明：集单日将会把满足起订量的订单下给工厂生产，如未满足起订量将顺延至下个集单日。紧急订单请申请总部安全库存支持。</div>
          <div class="item-button">
            <el-button class="item-button-add" @click="handleAddCart">
              <i class="iconfont iconzu21" />加入购物车
            </el-button>
            <el-button class="item-button-order" @click="handleOrderNow">
              立即订购
              <i class="iconfont iconzu121" />
            </el-button>
          </div>
        </div>
      </div>
      <!-- 商品详情 -->
      <div class="item-more">
        <!-- <div class="item-more-title">物料详情</div>
        <div class="item-more-content">
          <div v-html="itemInfo.itemDesc"></div>
          <div v-html="itemInfo.specInfo"></div>
        </div>-->

        <el-tabs value="first" type="card" class="item-more-tabs" stretch>
          <el-tab-pane label="物料详情" name="first">
            <div class="item-more-content">
              <div v-html="itemInfo.itemDesc"></div>
              <div v-html="itemInfo.specInfo"></div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="物料评价" name="second">
            <div class="eval-content" v-if="total">
              <div class="eval-item" style="margin:0 100px" v-for="evaluation in itemEvaluationList" :key="evaluation.evaluateId">
                <el-row>
                  <el-col class="avatar-info" :span="2">
                    <el-image :src="getImageUrl(evaluation.avatarImageUri)" alt />
                    <span>{{evaluation.createName}}</span>
                  </el-col>
                  <el-col class="eval-detail" :span="21" :offset="1">
                    <div class="eval-rate">
                      物料质量:
                      <span>{{evaluation.qualityScore + '.0'}}</span>
                      物料外观:
                      <span>{{evaluation.appearanceScore + '.0'}}</span>
                      物流服务:
                      <span>{{evaluation.serviceScore + '.0'}}</span>
                    </div>
                    <p v-if="evaluation.scoreContent" class="eval-text">{{evaluation.scoreContent}}</p>
                    <p v-else>用户没有填写评价！</p>
                    <div v-viewer="{ movable: true }" class="eval-imgList" v-if="evaluation.purchaseOrderEvaluateImageList.length">
                      <el-image
                        :src="getImageUrl(imgItem.imageFileUri)"
                        fit="cover"
                        v-for="imgItem in evaluation.purchaseOrderEvaluateImageList"
                        :key="imgItem.imageFileId"
                        alt
                      />
                    </div>
                    <div class="goods-info">
                      <span class="goods-info-name">{{itemInfo.itemName}}</span>
                      <span class="eval-time">{{evaluation.scoreTime | parseTime("{y}-{m}-{d} {h}:{i}")}}</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <div class="pag-row" v-if="total">
              <el-pagination
                background
                layout="total, prev, pager, next"
                :current-page="queryEvalForm.curPage"
                :page-size="queryEvalForm.pageSize"
                :total="total"
                @current-change="handleCurrentChange"
              />
            </div>
            <div class="eval-nothing" v-if="!total">暂无评价</div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
import itemApi from '@/api/item'
import baseApi from '@/api/base'
import { commonUtils } from '@/utils/common'
import { create, all } from 'mathjs/number'
const math = create(all)
export default {
  components: {
    ContentHeader
  },
  data () {
    return {
      soleBrandFlag: false,
      itemInfo: {},
      itemPrice: '16',
      totalAmount: '',
      activeName: 'detailInfo',
      srcList: [],
      url: '',
      fits: 'fill',
      pathInfo: [],
      infoLoading: false,
      curIndex: 0,
      showImage: '',
      itemParBrandList: [],
      itemSubBrandList: [],
      showSubBrandList: [],
      // itemParChannelList: [],
      itemSubChannelList: [],
      entityList: [],
      queryForm: {
        companyEntityId: this.$route.query.entityId,
        itemQuantity: null,
        itemId: '',
        mmr12: '',
        ledgerAccount: '',
        abiBrandId: '',
        subBrandId: ''
      },
      abiBrandId: '',
      itemType: '',
      cartId: '',
      // canSubmit: true,
      mmr12List: [],
      ledgerList: [],
      queryEvalForm: {
        curPage: 1,
        pageSize: 10,
        itemId: ''
      },
      itemEvaluationList: [],
      total: 0
    }
  },
  watch: {
    'queryForm.mmr12' (val) {
      this.queryForm.ledgerAccount = ''
      this.getLedgerList(val)
    },
    'queryForm.abiBrandId' (val) {
      this.queryForm.subBrandId = this.soleBrandFlag
        ? this.queryForm.subBrandId
        : ''
    }
  },
  filters: {
    formatScore (value) {
      if (value === Math.round(value)) {
        value = value + '.0'
      }
      return value
    }
  },
  created () {
    this.queryItemInfo()
    this.getEntity()
  },
  computed: {
    endTime () {
      let currentDate = Date.now()
      let RemainingTime = parseInt((this.itemInfo.contractEnd - currentDate) / (1000 * 3600 * 24))
      return RemainingTime
    },
    teamOrderEndTime () {
      let time
      if (this.itemInfo.approveDate) {
        let timestamp = this.itemInfo.approveDate + 28 * (24 * 60 * 60 * 1000)
        time = new Date(
          new Date(timestamp + 24 * 60 * 60 * 1000).toLocaleDateString()
        ).getTime()
      }
      return time
    }
  },
  methods: {
    // 获取商品信息
    queryItemInfo () {
      this.infoLoading = true
      itemApi.queryItemInfo(this.$route.params.id).then(res => {
        this.infoLoading = false
        if (res.data.resultCode === '0') {
          this.itemInfo = res.data.resultData.itemInfo
          this.queryItemEvaluation()
          this.setBrand()
          // this.queryForm.itemQuantity = this.itemInfo.priceUnitQuantity
          if (this.itemInfo.imageList && this.itemInfo.imageList.length) {
            this.showImage = this.itemInfo.imageList[0].imageFileUri
          }
          if (!this.queryForm.itemQuantity) this.queryForm.itemQuantity = 1
          let price = this.itemInfo.purchasePrice
          if (this.itemInfo.pocmPriceType === '02') {
            price = this.itemInfo.taxExcludedPrice
          }
          const rowPriceSum = Number(
            math
              .multiply(
                this.queryForm.itemQuantity / this.itemInfo.priceUnitQuantity,
                price
              )
              .toFixed(2)
          )
          const rowExtraSum = Number(
            math
              .multiply(
                this.queryForm.itemQuantity / this.itemInfo.priceUnitQuantity,
                this.itemInfo.extraFee
              )
              .toFixed(2)
          )
          this.totalAmount = math.add(rowPriceSum, rowExtraSum)
          this.totalAmount = Number(this.totalAmount)
            ? Number(commonUtils.formatNumber(this.totalAmount)).toFixed(2)
            : 0.01
          this.setPathInfo()
          this.setMmr12()
        }
      })
    },
    // 获取商品评论
    queryItemEvaluation () {
      this.queryEvalForm.itemId = this.itemInfo.itemId
      itemApi.queryItemEvaluation(this.queryEvalForm).then(res => {
        if (res.data.resultCode === '0') {
          this.total = res.data.resultData.pageInfo.totalCounts
          this.itemEvaluationList = res.data.resultData.purchaseOrderEvaluateInfo
        }
      })
    },

    handleCurrentChange (val) {
      this.queryEvalForm.curPage = val
      this.queryItemEvaluation()
    },

    // 展示可用库存相关
    showQty () {
      let hint = ''

      if (this.itemInfo.isPreOrder) {
        let availableQty = this.itemInfo.availableQty || 0
        hint = availableQty >= 0 ? `可用库存：${availableQty.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')}` : `待生产：${Math.abs(availableQty).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')}`
      }

      return hint
    },

    // 工厂
    getEntity () {
      baseApi.getItemCompany(this.$route.params.id).then(res => {
        if (res.data.resultCode === '0') {
          this.entityList = res.data.resultData.companyEntityList
        }
      })
    },

    // 品牌分类
    setBrand () {
      this.itemParBrandList = []
      this.itemSubBrandList = []
      this.itemInfo.abiBrandList.forEach(brand => {
        if (!brand.parentBrandId || brand.parentBrandId === '0') {
          this.itemParBrandList.push(brand)
        } else {
          this.itemSubBrandList.push(brand)
        }
      })

      // 品牌/子品牌唯一 直接展示
      if (
        this.itemParBrandList.length <= 1 &&
        this.itemSubBrandList.length <= 1
      ) {
        this.soleBrandFlag = true
        this.queryForm.abiBrandId =
          this.itemParBrandList.length === 1
            ? this.itemParBrandList[0].abiBrandId
            : ''
        this.queryForm.subBrandId =
          this.itemSubBrandList.length === 1 &&
            this.itemSubBrandList[0].brandGroup
            ? this.itemSubBrandList[0].abiBrandId
            : ''
      }
    },

    // 根据品牌联动子品牌下拉内容
    getSubBrandList (id) {
      let arr = []
      // 属于对应的主品牌 且 具有品牌组
      arr = this.itemSubBrandList.filter(item => {
        return item.parentBrandId === id && item.brandGroup
      })

      this.showSubBrandList = arr
    },

    // mmr12
    setMmr12 () {
      this.mmr12List = []
      this.mmr12List.push(
        {
          code: this.itemInfo.mmr12,
          name: this.itemInfo.mmr12Name
        },
        {
          code: this.itemInfo.nonChannelMmr12,
          name: this.itemInfo.nonChannelMmr12Name
        }
      )
      if (this.itemInfo.kaMmr12) {
        this.mmr12List.push({
          code: this.itemInfo.kaMmr12,
          name: this.itemInfo.kaMmr12Name
        })
      }
      const res = new Map()
      this.mmr12List = this.mmr12List.filter((a) => !res.has(a.code) && res.set(a.code, 1))
    },

    // 总账科目
    getLedgerList (code) {
      if (!code) {
        return
      }
      baseApi.getLedgerList(code).then(res => {
        if (res.data.resultCode === '0') {
          this.ledgerList = res.data.resultData.ledgerList
          if (this.ledgerList.length === 1) {
            this.queryForm.ledgerAccount = this.ledgerList[0].ledgerAccountCode
          }
        }
      })
    },

    handleShow (img, index) {
      this.showImage = img
      this.curIndex = index
    },

    // 加入常用物料
    inFavorite () {
      this.infoLoading = true
      const params = { itemId: this.itemInfo.itemId }
      itemApi.createFavItem(params).then(res => {
        if (res.data.resultCode === '0') {
          this.infoLoading = false
          this.queryItemInfo()
        }
      })
    },

    // 取消加入常用物料
    outFavorite () {
      this.infoLoading = true
      const id = this.itemInfo.favoriteItemDTO.favoriteId
      itemApi.deleteFacItem(id).then(res => {
        if (res.data.resultCode === '0') {
          this.infoLoading = false
          this.queryItemInfo()
        }
      })
    },

    // 添加pathInfo
    setPathInfo () {
      this.pathInfo = [{ path: '/material/index', name: '物料订购' }]
      if (this.itemInfo.isPrints) {
        this.pathInfo.push({ path: '/material/printing-list', name: '印刷品' })
      } else if (!this.itemInfo.isPrints && this.itemInfo.isStandard) {
        this.pathInfo.push({ path: '/material/menu-list', name: 'Menu清单' })
      } else {
        this.pathInfo.push({
          path: '/material/non-menu-more',
          name: 'Non-Menu'
        })
      }
    },

    // 数量改变时调用
    handleQuantityChange () {
      this.$nextTick(() => {
        //     if (
        //       this.queryForm.itemQuantity % this.itemInfo.priceUnitQuantity !==
        //       0
        //     ) {
        //       this.canSubmit = false
        //     } else {
        //       this.canSubmit = true
        //     }
        let price = this.itemInfo.purchasePrice
        if (this.itemInfo.pocmPriceType === '02') {
          price = this.itemInfo.taxExcludedPrice
        }
        const rowPriceSum = Number(
          math
            .multiply(
              this.queryForm.itemQuantity / this.itemInfo.priceUnitQuantity,
              price
            )
            .toFixed(2)
        )
        const rowExtraSum = Number(
          math
            .multiply(
              this.queryForm.itemQuantity / this.itemInfo.priceUnitQuantity,
              this.itemInfo.extraFee
            )
            .toFixed(2)
        )
        this.totalAmount = math.add(rowPriceSum, rowExtraSum)
        this.totalAmount = Number(this.totalAmount)
          ? Number(commonUtils.formatNumber(this.totalAmount)).toFixed(2)
          : 0.01
      })
    },

    // 点击加购
    setItemInfo () {
      this.queryForm.itemId = this.itemInfo.itemId
      if (!this.queryForm.abiBrandId) {
        let info = this.soleBrandFlag ? '商品品牌为空' : '请选择品牌'
        this.$message.error(info)
        return false
      }
      if (!this.queryForm.subBrandId) {
        let info = this.soleBrandFlag ? '商品子品牌为空' : '请选择子品牌'
        this.$message.error(info)
        return false
      }
      if (!this.queryForm.mmr12) {
        this.$message.error('请选择MMR12编码')
        return false
      }
      if (!this.queryForm.ledgerAccount) {
        this.$message.error('请选择总账科目')
        return false
      }
      if (!this.queryForm.companyEntityId) {
        this.$message.error('请选择工厂')
        return false
      }
      return true
    },
    handleAddCart () {
      // if (!this.canSubmit) {
      //   this.$message.error(
      //     `仅支持以${this.itemInfo.priceUnitQuantity}倍数量购买`
      //   )
      //   return
      // }
      if (!this.setItemInfo()) {
        return
      }
      this.$store
        .dispatch('addCart', this.queryForm)
        .then(res => {
          if (res.data.resultCode === '0') {
            this.$message.success('商品添加购物车成功')
          }
        })
        .catch(() => {
          this.$message.error('商品添加购物车失败')
        })
    },

    // 点击立即订购
    handleOrderNow () {
      // if (!this.canSubmit) {
      //   this.$message.error(
      //     `仅支持以${this.itemInfo.priceUnitQuantity}倍数量购买`
      //   )
      //   return
      // }
      if (!this.setItemInfo()) {
        return
      }
      this.$store
        .dispatch('addCart', this.queryForm)
        .then(res => {
          if (res.data.resultCode === '0') {
            this.cartId = res.data.resultData.cardId
            this.cartSettlement()
          }
        })
        .catch(() => {
          this.$message.error('商品购买失败')
        })
    },

    // 购物车数据结算
    cartSettlement () {
      let cartIdList = []
      cartIdList.push(this.cartId)
      this.$store.dispatch('cartSettlement', cartIdList).then(res => {
        if (res.data.resultCode === '0') {
          this.$router.push({ path: '/material/fill-order' })
        }
      })
    },

    getPrice (item) {
      if (!item.taxExcludedPrice) return
      return item.taxExcludedPrice.toFixed(2)
    },
    // 计算税额
    getTaxPrice (item) {
      return (item.taxRate * item.taxExcludedPrice).toFixed(2)
    },
    getImageUrl (url) {
      return commonUtils.getImageUrl(url)
    },
    // 计算百分比 （采购数量/最低起订量）*100
    getPercentage (item) {
      return item.sumPurchaseQuantity < Number(item.factoryMOQ)
        ? (item.sumPurchaseQuantity / Number(item.factoryMOQ)) * 100
        : 100
    },

    // 进度条内部显示数值 采购数量
    getShowQuantity (item) {
      return () => {
        if (!item.sumPurchaseQuantity && Number(item.factoryMOQ) !== 0) {
          return '0'
        }
        return item.sumPurchaseQuantity < Number(item.factoryMOQ)
          ? item.sumPurchaseQuantity
          : ''
      }
    },
    // 进度条尾部显示数值 最低起订量
    getShowMOQ (item) {
      return item.sumPurchaseQuantity < Number(item.factoryMOQ)
        ? item.factoryMOQ
        : '满'
    }

    // radio点击取消
    // clickBrand (id) {
    //   if (id === this.queryForm.abiBrandId) {
    //     this.queryForm.abiBrandId = ''
    //   } else {
    //     this.queryForm.abiBrandId = id
    //   }
    // },
    // clickSubBrand (id) {
    //   if (id === this.queryForm.subBrandId) {
    //     this.queryForm.subBrandId = ''
    //   } else {
    //     this.queryForm.subBrandId = id
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.item-detail {
  display: flex;
  margin-bottom: 17px;
  width: 100%;
  background: $base-white;
  border-radius: 6px;
  .item-image {
    position: relative;
    width: 460px;
    // height: 515px;
    padding: 15px 23px 0 23px;
    box-shadow: 0 0px 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .item-image-large {
      height: 414px;
      line-height: 414px;
      text-align: center;
      // display: flex;
      // align-items: center;
      // justify-content: center;
      img {
        max-width: 100%;
        max-height: 100%;
        vertical-align: middle;
      }
    }
    .item-image-preview {
      padding-top: 10px;
      margin-bottom: 10px;
      display: flex;
      justify-content: center;
      .item-image-small {
        height: 50px;
        line-height: 50px;
        width: 50px;
        border: 1px solid #ddd;
        margin-right: 10px;
        text-align: center;
        // display: flex;
        // align-items: center;
        // justify-content: center;
        img {
          max-width: 100%;
          max-height: 100%;
          vertical-align: middle;
        }
      }
      .active {
        border-color: $base-red;
      }
    }
    .iconlove-b {
      position: absolute;
      top: 15px;
      left: 15px;
      font-size: 32px;
      color: #aaa;
    }
  }
  .item-info {
    flex: 0.54 1 auto;
    height: 100%;
    width: calc(100% - 460px);
    .item-title {
      padding: 15px 0 0 63px;
      line-height: 35px;
      font-size: 25px;
      font-weight: bold;
      letter-spacing: 0px;
    }
    .item-info-box {
      width: 100%;
      padding-left: 63px;
      box-sizing: border-box;
      .item-info-detail {
        font-size: $font-12;
        line-height: 24px;
        // div {
        //   margin-top: 2px;
        // }
      }
      .info-important {
        font-weight: bold;
      }
      .contract-endtime {
        font-size: 14px;
        margin-left: 10px;
        color: #c8102d;
      }
      .item-info-radio {
        display: flex;
        margin-top: 5px;
        flex-wrap: wrap;
        font-size: 12px;
        .el-col-2,
        .el-col-3 {
          padding-top: 8px;
        }
        .el-radio-group {
          margin-right: 10px;
          margin-bottom: 5px;
        }
      }
    }
    .item-entity,
    .item-mmr12,
    .item-brand {
      margin: 8px 0 0 63px;
      font-size: 12px;
      line-height: 28px;
      .el-select {
        width: 210px;
      }
    }
    .item-price,
    .item-price-extra {
      margin: 25px 38px 0 38px;
      position: relative;
      .item-price-unit {
        display: inline-block;
        padding: 0 0 5px 20px;
        font-size: 24px;
        font-weight: bold;
        color: $base-red;
      }
      .item-price-desc {
        display: inline-block;
        padding-left: 20px;
        font-size: $font-12;
        color: #999;
      }
      .item-price-msg {
        display: block;
        padding-left: 20px;
        line-height: 30px;
        font-size: 13px;
        color: $base-red;
      }
      .item-price-extra {
        font-size: 13px;
        color: $base-red;
      }
    }
    .item-price-extra {
      margin-top: 10px;
      .item-price-unit {
        font-size: 18px;
      }
    }
    .item-price-bottom {
      border-bottom: 1px solid #ccc;
    }
    .item-quantity {
      padding: 15px 0 15px 20px;
      margin: 0 38px;
      border-bottom: 1px solid $base-grey;
      .item-quantity-info {
        padding-right: 42px;
        font-size: $font-12;
        color: #333333;
      }
      .item-price-total {
        padding-left: 87px;
        font-size: $font-14;
        line-height: 24px;
        color: #333333;
      }
    }
    .order-msg {
      padding: 10px 30px 0 40px;
      color: $base-red;
      font-size: 12px;
      line-height: 16px;
    }
    .item-button {
      margin-top: 25px;
      padding-bottom: 10px;
      text-align: center;
      .item-button-add {
        width: 160px;
        border: 1px solid $base-orange;
        color: $base-orange;
      }
      .item-button-order {
        width: 160px;
        background-color: $base-red;
        color: $base-white;
      }
      .iconfont {
        padding: 0 5px;
      }
    }
  }
  .item-info-print {
    .item-title {
      padding-bottom: 5px;
    }
    .item-price {
      margin-top: 25px;
      .item-price-unit {
        padding: 0 0 5px 20px;
      }
    }
    .item-info-detail {
      font-size: $font-12;
      line-height: 22px !important;
    }
    .item-info-radio {
      margin-top: 5px !important;
    }
    .item-quantity {
      padding: 15px 0 15px 20px;
      border-bottom: 1px solid $base-grey;
    }
    .item-button {
      margin-top: 30px;
      padding-bottom: 15px;
      .iconfont {
        padding: 0 5px;
      }
    }
  }
}
.item-more {
  background-color: $base-white;
  border-radius: 6px;
  .item-more-title {
    width: 100px;
    text-align: center;
    height: 36px;
    line-height: 36px;
    border: 1px solid #eee;
    margin: auto;
    color: $base-red;
  }
  .item-more-content {
    padding: 5px 100px $content-middle 100px;
  }
}
.item-msg {
  color: $base-red;
  padding-left: 62px;
  font-size: 12px;
  margin-top: 5px;
}
.item-available-quantity {
  font-size: 12px;
  padding-left: $page-middle;
}
.rate {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .rate-item {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
    text-align: left;
    span{
      line-height: 20px;
    }
    .rate-item-score{
      color: #c8102d;
      // font-weight: 600;
    }
  }
}
.el-rate {
  display: inline;
  margin-left: 10px;
  width: 122px;
}
.rate-nothing {
  text-align: center;
  padding-top: 50px;
}
.eval-nothing {
  text-align: center;
  padding: 150px 0;
}
.eval-item {
  padding: 15px 0 20px 0;
  border-bottom: 1px solid #e8e8e8;
  .el-image {
    width: 50px;
    height: 50px;
  }
}
.avatar-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  .el-image {
    margin: 20px 0 10px 0;
  }
}
.eval-detail {
  padding-top: 20px;
  .eval-text {
    line-height: 20px;
  }
}
.eval-imgList {
  margin-bottom: 10px;
  .el-image {
    margin-right: 10px;
    cursor: pointer;
  }
}
.goods-info {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  color: #999;
}
.pag-row {
  padding-bottom: 20px;
}
.item-more ::v-deep .el-tabs__item.is-active {
  color: #c8102d;
}
.item-more ::v-deep .el-tabs__item:hover {
  color: #c8102d;
}
::v-deep .el-tabs__header {
  width: 350px;
  margin: auto;
}
.eval-rate {
  font-size: 13px;
  span {
    color: #c8102d;
    margin-left: 5px;
    margin-right: 30px;
    font-weight: 700;
  }
}
.teamOrder-box {
  display: flex;
  flex-wrap: wrap;
}
.teamOrder {
  font-weight: 700;
  width: 50%;
  margin-bottom: 15px;
}
.sumPurchaseQty {
  display: flex;
}
.item-progress {
  flex: 1;
  display: flex;
  color: #888;
  .el-progress {
    width: 70%;
    height: 15px;
    margin-right: 5px;
    margin-left: 5px;
  }
}
::v-deep .el-progress-bar__outer {
  background-color: rgb(239, 171, 171);
}

::v-deep .el-image {
  border-radius: 3px;
}
</style>
